import { parseResponse } from '$lib/client/responseHelpers';

import { client } from '@api/client';
import type { ConversationList, MessageList } from '@api/types';

export const initConversation = async (userId: string): Promise<string> => {
    const data = await client.POST('/conversation-http/{userId}/init', {
        params: {
            path: { userId },
        },
    });
    return parseResponse(data).id;
};

export const loadConversations = async (activeConversationId?: string): Promise<ConversationList> => {
    const data = await client.GET('/conversation-http', {
        params: { query: { activeConversationId } },
    });
    return parseResponse(data);
};

export const messageUnreadCount = async (): Promise<number> => {
    const data = await client.GET('/conversation-http/unread/count', {});
    return parseResponse(data).value;
};

export const loadMessages = async (conversationId: string, messageId?: string): Promise<MessageList> => {
    const data = await client.GET('/conversation-http/{conversationId}', {
        params: {
            path: { conversationId },
            query: { messageId },
        },
    });
    return parseResponse(data);
};

export const readMessages = async (conversationId: string): Promise<void> => {
    const data = await client.POST('/conversation-http/{conversationId}/read', {
        params: {
            path: { conversationId },
        },
    });
    return parseResponse(data);
};

export const deleteMessages = async (conversationId: string): Promise<void> => {
    await client.DELETE('/conversation-http/{conversationId}', {
        params: {
            path: { conversationId },
        },
    });
};
